import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-2" }
const _hoisted_2 = { class: "relative inline-flex items-center cursor-pointer" }
const _hoisted_3 = ["value", "checked"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "w-11 h-6 bg-white peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600" }, null, -1)
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = {
  key: 0,
  class: "flex items-center text-blue"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-link-45deg",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M4.715 6.542 3.343 7.914a3 3 0 1 0 4.243 4.243l1.828-1.829A3 3 0 0 0 8.586 5.5L8 6.086a1.002 1.002 0 0 0-.154.199 2 2 0 0 1 .861 3.337L6.88 11.45a2 2 0 1 1-2.83-2.83l.793-.792a4.018 4.018 0 0 1-.128-1.287z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M6.586 4.672A3 3 0 0 0 7.414 9.5l.775-.776a2 2 0 0 1-.896-3.346L9.12 3.55a2 2 0 1 1 2.83 2.83l-.793.792c.112.42.155.855.128 1.287l1.372-1.372a3 3 0 1 0-4.243-4.243L6.586 4.672z" })
], -1)

import { PropType, computed } from "vue";
import { Event } from "@/types";
import { useGlobalStore } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'EventVisibilitySwitch',
  props: {
  event: {
    type: Object as PropType<Event>,
    required: true,
  },
},
  emits: ["change"],
  setup(__props, { emit: emits }) {

const props = __props;

const globalStore = useGlobalStore();



const type = computed(() => {
  if (props.event.visibility) {
    return "bg-alert-success border-alert-success-600";
  }
  return "bg-alert-secondary border-[#D3D6D8]";
});

async function emitEventChange() {
  return emits("change");
}

function copyLink(type: 'group' | 'individual') {
  let url = "";

  if (props.event.level === "subscription")
    url = "courses/register-for-a-training-course/book/subscription";
  if (props.event.level === "Trainer (props.event.level 4a)")
    url = "courses/register-for-a-training-course/register-for-level-4a-course";
  if (props.event.level === "Trainer")
    url = "courses/register-for-a-training-course/book/advanced-facilitator";
  if (props.event.level === "Specialist (props.event.level 3)")
    url = "courses/register-for-a-training-course/book/level-3";
  if (props.event.level === "Advanced Facilitator")
    url = "courses/register-for-a-training-course/book/advanced-facilitator";
  if (props.event.level === "Certified Facilitator" || props.event.level === "L1 and L2 Combined")
    url = "courses/register-for-a-training-course/book/certified-facilitator";
  if (props.event.type === "introductory")
    url = "courses/register-for-a-training-course/book/introductory";
  if (props.event.type === "drop-in")
    url = "courses/register-for-a-training-course/book/drop-in";
  if (props.event.type === "cpd-for-certified-facilitators")
    url = "courses/register-for-a-training-course/book/cpd-for-facilitators";
  if (props.event.type === "continuing-professional-development")
    url = "courses/register-for-a-training-course/book/cpd";

  navigator.clipboard.writeText(`${process.env.VUE_APP_WEBSITE_URL}/${url}/${type}?token=${props.event.link_token}`);
  globalStore.toast("SUCCESS", "Event link copied");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_unref(type), 'flex items-center p-4 justify-between border rounded text-alert-secondary-600'])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("label", _hoisted_2, [
          _createElementVNode("input", {
            type: "checkbox",
            value: __props.event.visibility,
            checked: __props.event.visibility,
            class: "sr-only peer",
            onChange: _cache[0] || (_cache[0] = ($event: any) => (emitEventChange()))
          }, null, 40, _hoisted_3),
          _hoisted_4
        ])
      ]),
      _createElementVNode("div", null, [
        _createTextVNode(_toDisplayString(_ctx.$t("this-event-is")) + " ", 1),
        _createElementVNode("strong", null, _toDisplayString(__props.event.visibility ? _ctx.$t("public") : _ctx.$t("private")), 1),
        _createTextVNode(" " + _toDisplayString(__props.event.visibility ? _ctx.$t("viewable-on-website") : _ctx.$t("not-viewable-on-website")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (!__props.event.visibility)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("button", {
              class: "underline hover:text-blue-600 active:text-blue-600",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (copyLink('individual')))
            }, _toDisplayString(_ctx.$t('copy-individual-link')), 1),
            _createTextVNode("   "),
            _createElementVNode("button", {
              class: "underline hover:text-blue-600 active:text-blue-600",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (copyLink('group')))
            }, _toDisplayString(_ctx.$t('copy-group-link')), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})